import { createAction, props, union } from '@ngrx/store';
import { QuaCarriageQueryI } from 'src/app/api/qua-carriage/qua-carriage.query.int';
import { QuaCarriageI } from 'src/app/api/qua-carriage/qua-carriage.result.int';

export const error = createAction('[QUA / Carriage] Error', props<{ messageText: string }>());
export const load = createAction('[QUA / Carriage] Get', props<{
    query: QuaCarriageQueryI;
}>());
export const received = createAction('[QUA / Carriage] Received', props<{
    result: QuaCarriageI;
}>());
export const reset = createAction('[QUA / Carriage] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
